import React from 'react';

import { Card, CardBody, CardHeader, Image, Spinner, Text } from '@change/ds-core-ui';
import { CloseIcon, TikTokIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core-react/i18n';

export const LinkChip: React.FC<Props> = ({ handle, title, image, onRemove, 'data-qa': dataQa }) => {
	const { translate } = useI18n();

	return (
		<div className="w-full px-2 pt-2">
			<Card
				as="button"
				type="button"
				orientation="horizontal"
				reverse
				aria-label={translate('corgi.homepage.hero_section.remove_link_button_label')}
				className="relative w-full [grid-template-columns:8rem_1fr] text-left [--card-gap:0.2rem] [--card-padding:0.5rem]"
				data-qa={dataQa}
				onClick={onRemove}
				elevation
			>
				<CardHeader className="flex items-center justify-center">
					<div className="h-full w-26 shrink-0 py-2">
						{image ? (
							<Image aspectRatio="4:3" src={image} alt={handle} className="h-full w-full rounded-sm object-cover" />
						) : (
							<Spinner className="size-4" />
						)}
					</div>
				</CardHeader>
				<CardBody className="flex min-w-0">
					<div className="flex min-w-0 flex-1 flex-col justify-center pr-8">
						<div className="flex items-center gap-1">
							<div className="bg-fill-strong flex h-4 w-4 shrink-0 items-center justify-center rounded-md">
								<TikTokIcon size={10} className="text-icon-inverse-strong" />
							</div>
							<Text as="p" className="text-typography-weak line-clamp-2 break-words" size="x-small">
								tiktok.com • {handle ?? translate('corgi.homepage.hero_section.input_chip_fallback_label')}
							</Text>
						</div>
						{title && (
							<Text size="small" fontWeight="bold" className="line-clamp-3">
								{title}
							</Text>
						)}
					</div>
				</CardBody>
				<div
					aria-hidden="true"
					className="bg-fill-weaker text-icon-weak absolute top-2 right-2 flex h-6 w-6 items-center justify-center rounded-full"
				>
					<CloseIcon size="x-small" />
				</div>
			</Card>
		</div>
	);
};

type Props = Readonly<{
	handle: string | undefined;
	title?: string;
	image?: string;
	onRemove: () => void;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'data-qa': string;
}>;
